<template>
	<div class="full">
		<vxe-grid ref="inventoryTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" :cellStyle="cellStyle"></vxe-grid>
<!-- 		<trade-box ref="tradeBox" :currentrow="currentrow" :invoiceNumber="invoiceNumber"  @submit="tradeBoxSubmit" />
		<sku-box ref="skuBox" :currentrow="currentrow" @submit="skuSubmit" /> -->
		
		<edit-from :currentrow="currentrow" :invoiceNumber="invoiceNumber" :invoicedata="invoicedata" ref="matchEditForm" @success="editSubmit" :store="store" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	// import tradeBox from './box/trade.vue'
	// import skuBox from './box/sku.vue'
	import editFrom from './edit/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			invoicedata: {
				default: () => {
					return {}
				}
			},
			store: {
				default: () => {
					return {}
				}
			},			
		},
		data() {
			return {
				invoiceNumber:null,
				currentrow:null,
				list_footerField:[
					{field:'inAmount',toFixed:4},
					{field:'outAmount',toFixed:4},
					{field:'endAmount',toFixed:4}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			match(row){
				this.currentrow = row
				this.invoiceNumber = row.invoiceNumber
				this.$nextTick(()=>{
					this.$refs.matchEditForm.modal_show()
					// this.$refs.skuBox.initList()
					// this.$refs.skuBox.box.alertBox()
				})
				// this.$refs.tradeBox.initList()
				// this.$refs.tradeBox.box.alertBox()
			},
			clearmatch(row){
				this.$confirm('是否确认清空').then(()=>{
					this.$api.invoice.clearmatchgoods({cargoId:row.cargoId}).then(()=>{
						this.customreload()
					})
				})
			},
			customreload() {
				this.$nextTick(() => {
					this.$refs.inventoryTable.commitProxy('query')
				})
			},
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:60,
						treeNode:true,				
					},{
						field: 'pic',
						title: '图片',
						width:50,
						align:'center',	
						slots:{
							default:({row})=>{
								return <el-image style="width: 25px; height: 25px" src={row.pic}  preview-src-list={[row.pic]}></el-image>
							}
						},					
					},{
						field: 'groupcode',
						title: '组合编码',
						width:120,						
					},{
						field: 'cargoName',
						title: '项目名称',
						width:100,	
					},
					{
						field: 'spec',
						title: '规格型号',
						width:100,	
					},
					{
						field: 'unit',
						title: '开票单位',
						width:50,	
					},
					{
						field: 'amount',
						title: '开票数量',
						width:50,	
					},
					{
						field: 'unitPrice',
						title: '开票单价',
						width:50,	
					},
					{
						field: 'inventoryUnitConversion',
						title: '单位比例',
						width:50,	
					},
					{
						field: 'inventoryunit',
						title: '出库单位',
						width:50,	
					},
					{
						field: 'inventoryamount',
						title: '出库数量',
						width:50,	
					},
					{
						field: 'inventoryunitPrice',
						title: '出库单价',
						width:50,	
					},
					{
						field: 'cost',
						title: '成本',
						width:50,	
					},
					{
						field: 'price',
						title: '金额',
						width:50,	
					},
					{
						field: 'taxRateWithPercent',
						title: '税率',
						width:50,
					},
					{
						field: 'taxPrice',
						title: '税额',
						width:50,	
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 125,
						slots: {
							default: ({row}) => {
								if(!row.parentid){
									return [
										<el-button type = "text" size = "mini" onClick = {() => {this.match(row)}}>匹配商品</el-button>,
										<el-button type = "text" size = "mini" onClick = {() => {this.clearmatch(row)}}>清空</el-button>
									]
								}
								return null
								
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = false
				gridOptions.treeConfig = {
					lazy: false,
					transform: true,
					rowField: 'id',
					parentField: 'parentid',
					line: false,
					expandAll: true,
					indent:0
				}
			},
			list() {
				return new Promise((resolve) => {
					this.$api.invoice.getoutputinvoicedetail({
						invoiceNumber: this.invoicedata.invoiceNumber
					}).then((res) => {
						let data = []
						res.forEach((item)=>{
							item.parentid = 0							
							data.push(item)
							if(item.orderdetail){
								item.pic = item.orderdetail.platformUrl
							}
							item.inventoryamount = item.totalamount
							item.inventoryunit = item.goodsunit
							item.inventoryunitPrice = item.goodsunitprice
							item.goods.forEach((_item)=>{
								data.push({
									pic:_item.pic,
									groupcode:_item.goodscode,
									cargoName:_item.goodsname,
									spec:_item.goodsmodel,
									inventoryamount:(_item.nums * item.amount).toFixed(2),
									inventoryunit:_item.unit,
									inventoryunitPrice:_item.unitPrice,
									price:_item.price,
									cost:_item.cost,
									taxRateWithPercent:_item.taxRateWithPercent,
									taxPrice:_item.taxPrice,
									parentid:item.id
								})
							})
						})
						//console.log(data)
						resolve({
							list: data
						})					
					}, () => {
						resolve()
					})
				})
			},
			cellStyle({row}) {
				//console.log(row)
				if (!row.children.length && !row.parentid) {
					return {
						backgroundColor: 'rgb(253, 226, 226)'
					}
				}
			},
			editSubmit(e){
				this.$api.invoice.addmatchgoods(e.data).then(()=>{
					this.$refs.matchEditForm.modal_cancel()
					this.customreload()
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			editFrom,
			// tradeBox,
			// skuBox
		}
	}
</script>